<brands-form [brandsForm]="brandsForm"></brands-form>